import React, { useState } from "react";
import "./faq_questions_card.css";

const FaqQuestionCard = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleFAQ = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="faq">
            <div className={`faq_questions ${isOpen ? "open" : ""}`} onClick={toggleFAQ}>
                <div className="question">
                    <p>{question}</p>
                </div>
                <div className="icon">
                    <p>{isOpen ? "-" : "+"}</p>
                </div>
            </div>
            <div className={`faq_details ${isOpen ? "open" : ""}`}>
                <div className="faq_answer">
                    <p>{answer}</p>
                </div>
            </div>
            <div className="faq_line"></div>
        </div>
    );
};

export default FaqQuestionCard;
